import React from "react"
import "./no-record.scss"

export default function NoRecord() {
    return(
        <p className={'no-record-message'}>No Record Found!</p>
    )
}